import axios from 'axios';
import { header } from './header.encry';

const API_URL = process.env.REACT_APP_PEGASUS_API_URL;

export const fetchTokens = async () => {
  const res = await axios.get(`${API_URL}/tokens`, header());
  return res.data;
};

export const getToken = async (id) => {
  const res = await axios.get(`${API_URL}/tokens/${id}`, header());
  return res.data;
};

export const createToken = async (payload) => {
  const res = await axios.post(`${API_URL}/tokens`, payload, header());
  return res.data;
};

export const updateToken = async (id, payload) => {
  const res = await axios.put(`${API_URL}/tokens/${id}`, payload, header());
  return res.data;
};

export const deleteToken = async (id) => {
  const res = await axios.delete(`${API_URL}/tokens/${id}`, header());
  return res.data;
};

export default {
  fetchTokens,
  getToken,
  createToken,
  updateToken,
  deleteToken,
};
